import ClientBase from "../ClientBase";
import SiteViewModel from "@/domain/site/SiteViewModel";

const BASE_URL = "api/v1/sites";

class SiteClient extends ClientBase {

    async getSitesByOrganizationId(organizationId) {
        const data = await this.get(`${BASE_URL}/organizations/${organizationId}`);
        return data?.map(s => new SiteViewModel(s)) ?? [];
    }

    async getSite(organizationId, id) {
        const data = await this.get(`${BASE_URL}/${organizationId}/${id}`);
        return data ? new SiteViewModel(data) : null;
    }

    async createSite(request) {
        const data = await this.post(BASE_URL, request);
        return data ? new SiteViewModel(data) : null;
    }

    async updateSite(organizationId, id, request) {
        const data = await this.put(`${BASE_URL}/${organizationId}/${id}`, request);
        return data ? new SiteViewModel(data) : null;
    }

    async deleteSite(organizationId, id, softDelete = true) {
        return await this.delete(`${BASE_URL}/${organizationId}/${id}`, { softDelete });
    }
}

export default new SiteClient();
